import * as React from "react";
function DollarCircleFillIcon() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "50px"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0m1.464 18.587a.25.25 0 0 0-.214.248v.765a1.25 1.25 0 1 1-2.5 0v-.705c0-.137-.11-.25-.248-.25H9.353a1.25 1.25 0 1 1 0-2.5h3.588a1.118 1.118 0 0 0 .415-2.156l-3.64-1.457a3.605 3.605 0 0 1 .82-6.92.25.25 0 0 0 .214-.247V4.6a1.25 1.25 0 1 1 2.5 0v.706c0 .138.112.25.25.25h1.147a1.25 1.25 0 1 1 0 2.5h-3.588a1.117 1.117 0 0 0-.415 2.155l3.64 1.457a3.605 3.605 0 0 1-.82 6.92z"
  }));
}
export default DollarCircleFillIcon;